import { createFileRoute } from '@tanstack/react-router';

/** Renders nothing, so a closed sheet is a real URL; the shell (`partner-ngos.tsx`) owns the page. */
export const Route = createFileRoute('/www/partner-ngos/')({
	component: () => null,
});
